import { registerNode } from '../../structor/node-helpers';
import { debugScopeNode } from './nodes';

registerNode(debugScopeNode);
